<script>
import Splash from "@/components/Splash/Splash.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Introduction
  from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Introduction.vue";
import KavehPars from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/index.vue";
import FooladKaveh
  from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/FooladKaveh/index.vue";
import SimanTehran
  from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/SimanTehran/index.vue";
import KashiCeramicSina
  from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/KashiCeramicSina/index.vue";
import Report from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Report.vue";

export default {
  components: {Report, KashiCeramicSina, SimanTehran, FooladKaveh, KavehPars, Sidebar, Splash, Introduction},
  data() {
    return {
      activeTab: 'kaveh-pars'
    }
  },
}
</script>

<template>
  <splash/>
  <div class="container mt-4" dir="rtl">
    <sidebar/>
    <div class="card-panel-main col-lg-9 mb-5 p-4">
      <div class="card">
        <Report/>

        <Introduction/>

        <div class="tab-container">
          <!-- Nav tabs -->
          <ul class="nav nav-tabs justify-content-center bg-white" id="companyTabs">
            <li class="nav-item">
              <button
                  class="nav-link"
                  :class="{active: activeTab === 'kaveh-pars'}"
                  @click="activeTab = 'kaveh-pars'"
                  id="kaveh-pars-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#kaveh-pars"
              >
                هلدینگ
              </button>
            </li>
            <li class="nav-item">
              <button
                  class="nav-link"
                  :class="{active: activeTab === 'foolad-kaveh'}"
                  @click="activeTab = 'foolad-kaveh'"
                  id="foolad-kaveh-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#foolad-kaveh"
              >
                فولاد کاوه جنوب کیش
              </button>
            </li>
            <li class="nav-item">
              <button
                  class="nav-link"
                  :class="{active: activeTab === 'siman-tehran'}"
                  @click="activeTab = 'siman-tehran'"
                  id="siman-tehran-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#siman-tehran"
              >
                سیمان تهران
              </button>
            </li>
            <li class="nav-item">
              <button
                  class="nav-link"
                  :class="{active: activeTab === 'kashi-ceramic-sina'}"
                  @click="activeTab = 'kashi-ceramic-sina'"
                  id="kashi-ceramic-sina-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#kashi-ceramic-sina"
              >
                کاشی و سرامیک سینا
              </button>
            </li>
          </ul>

          <!-- Tab content -->
          <div class="tab-content" id="companyTabsContent">
            <div
                class="tab-pane fade"
                :class="{'show active': activeTab === 'kaveh-pars'}"
                id="kaveh-pars"
            >
              <KavehPars/>
            </div>
            <div
                class="tab-pane fade"
                :class="{'show active': activeTab === 'foolad-kaveh'}"
                id="foolad-kaveh"
            >
              <FooladKaveh/>
            </div>
            <div
                class="tab-pane fade"
                :class="{'show active': activeTab === 'siman-tehran'}"
                id="siman-tehran"
            >
              <SimanTehran/>
            </div>
            <div
                class="tab-pane fade"
                :class="{'show active': activeTab === 'kashi-ceramic-sina'}"
                id="kashi-ceramic-sina"
            >
              <KashiCeramicSina/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card-panel-main {
  transform: translateX(-19vw);
}

.tab-container {
  padding: .3vw;
  background: #f0f2f5;
}

.nav.nav-tabs {
  margin: 1.5vw;
  padding: .7vw;
  border-radius: .5vw;
  position: sticky;
  top: 0;
  z-index: 15;
  box-shadow: 0 .2vw .2vw rgba(197, 197, 197, 0.4);
}

.nav-link.active {
  color: white;
  background: #3742FA;
}
</style>
